<template>
  <div class="row">
    <div class="col-lg-8">
      <h2 class="inline">Follow Up</h2>
    </div>

    <div class="col-lg-12">
      <hr />
    </div>
    <div class="col-md-12">
      <card card-body-classes="table-full-width">
        <h4 slot="header" class="card-title">
          List of Complete Investigation Report
        </h4>
        <div>
          <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <base-input label="rows visible">
              <el-select
                class="select-info mb-3 pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                ></el-option>
              </el-select>
            </base-input>
            <base-input>
              <el-input
                type="search"
                class="mb-3 search-input"
                clearable
                prefix-icon="el-icon-search"
                placeholder="Search records"
                v-model="searchQuery"
                aria-controls="datatables"
              ></el-input>
            </base-input>
          </div>
          <el-table
            :data="queriedData"
            @select="handleSelectionChange"
            :header-cell-style="{
              background: 'transparent',
              border: 'none',
              borderBottom: '0.5px solid #3d3f51',
            }"
            :cell-style="{
              border: 'none',
              borderBottom: '0.5px solid #3d3f51',
            }"
          >
            <el-table-column
              v-if="false"
              :min-width="130"
              prop="InstID"
            ></el-table-column>
            <el-table-column
              :min-width="130"
              label="Case No"
              prop="ControlCaseNo"
            ></el-table-column>
            <el-table-column
              :min-width="130"
              label="Date of Investigation"
              prop="DateOfInst"
            ></el-table-column>
            <el-table-column
              :min-width="130"
              label="Officer Name"
              prop="InstName"
            ></el-table-column>
            <el-table-column
              :min-width="130"
              label="Staff ID"
              prop="InstStaffID"
            ></el-table-column>
            <el-table-column :min-width="135" align="right" label="Actions">
              <div slot-scope="props">
                <el-tooltip content="Edit" placement="bottom" effect="light">
                  <base-button
                    @click.native="getRow(props.$index, props.row)"
                    class="edit btn-link"
                    type="info"
                    size="sm"
                    icon
                  >
                    <i class="tim-icons icon-pencil"></i>
                  </base-button>
                </el-tooltip>
              </div>
            </el-table-column>
          </el-table>
        </div>
        <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <div class>
            <p class="card-category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <base-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          ></base-pagination>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { BasePagination } from "src/components";
import { Table, TableColumn, Select, Option, DatePicker } from "element-ui";
import Fuse from "fuse.js";
import swal from "sweetalert2";
import jsPDF from "jspdf";

export default {
  components: {
    BasePagination,
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },

  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
  },

  data() {
    return {
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      searchQuery: "",
      propsToSearch: ["ControlCaseNo", "InstName"],
      tableData: [],
      searchedData: [],
      fuseSearch: null,
    };
  },

  methods: {
    getRow(index, row) {
      this.$router.push({ path: `/IncidentReport/FollowUp/${row.InstID}` });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getInstReport() {
      this.tableData = [];
      this.$http.get(":9994/api/v1/complete/list").then((res) => {
        if (!res.error) {
          // this.tableData = res.message;
          let response = res.message;

          for (var i = 0; i < response.length; i++) {
            let obj = {
              ControlCaseNo: response[i].ControlCaseNo,
              DateOfInst: response[i].DateOfInst,
              InstID: response[i].InstID,
              InstName: response[i].InstName,
              InstStaffID: response[i].InstStaffID,
            };
            this.tableData.push(obj);
          }
        }
      });
    },
  },
  created() {
    this.getInstReport();
  },
  mounted() {
    // Fuse search initialization.
    this.fuseSearch = new Fuse(this.tableData, {
      keys: ["ControlCaseNo", "InstName"],
      threshold: 0.3,
    });
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
  },
};
</script>
<style lang="scss" scoped>
.inline {
  margin-top: 1.5%;
  margin-bottom: 1%;
}
hr {
  margin-top: 0%;
}
.style-date {
  margin-bottom: 1%;
}
.style-select {
  padding-top: 1%;
}
</style>
